import React from 'react';
import Styled from './FunctionNameCellRenderer.styles';
import { isUnnamed } from '../../utils';
import { APILabel } from '../endpointsCellRenderer/endpointsCellRenderer.styles';
import { useFiltersForFunction } from '../../hooks/useFiltersForFunction';
import { CellContext } from '@tanstack/react-table';
import { FunctionData } from '@hud/portal-dtos/webapp-function.dto';
import { BreadcrumbItem } from '@hud/web-components/Breadcrumbs/Breadcrumbs';
export default function renderFunctionName<
  TData extends FunctionData,
  TValue extends string,
>(
  aggregatedEndpoint: number | undefined,
  aggregatedService?: number | undefined,
  referralBreadcrumbs?: BreadcrumbItem[],
  tags?: Record<string, string>,
) {
  return function CellRenderer(cell: CellContext<TData, TValue>) {
    const filtersForFunction = useFiltersForFunction(
      aggregatedEndpoint,
      aggregatedService
        ? [{ id: aggregatedService }]
        : cell.row.original.services,
      tags,
    );
    return (
      <Styled.LinkCell
        to={`/explore/functions/${cell.row.original.id}?${filtersForFunction}`}
        state={{ referralBreadcrumbs: referralBreadcrumbs }}
      >
        <Styled.EntityIcon thirdPartyModule={cell.row.original.thirdPartyModule} />
        <Styled.StyledPopover
          popoverContent={
            <Styled.FunctionPopover>
              <Styled.Signature>{cell.getValue()}</Styled.Signature>
              <Styled.FilePath>
                <span>File path: </span>
                <span>
                  {cell.row.original.filePath}:{cell.row.original.lineNumber}
                </span>
              </Styled.FilePath>
            </Styled.FunctionPopover>
          }
          >
          {isUnnamed(cell.getValue()) &&
          cell.row.original.totalEndpoints === 1 &&
          !['query', 'mutation'].includes(
            cell.row.original.endpoints[0].method,
          ) ? ( // exclude GraphQL queries and mutations
            <APILabel>
              {cell.row.original.endpoints[0].method.toLocaleUpperCase() +
                ' ' +
                cell.row.original.endpoints[0].path}
            </APILabel>
          ) : (
            cell.getValue()
          )}
        </Styled.StyledPopover>
      </Styled.LinkCell>
    );
  };
}
